import { render, staticRenderFns } from "./Japan.vue?vue&type=template&id=3c109b43&"
import script from "./Japan.vue?vue&type=script&lang=ts&"
export * from "./Japan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports